import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

export class AssetsEndpoints {

	constructor(private http: HttpClient) {
	}

	getCertificationBodiesFor(countryCode: string): Observable<string> {
		let url = 'assets/certification-bodies_' + countryCode + '.txt';
		return this.http.get(url, {responseType: "text", headers: {'Content-Type': 'text/plain'}})
	}

	getCountryCodes(): Observable<string> {
		return this.http.get('assets/country-codes.txt', {responseType: "text", headers: {'Content-Type': 'text/plain'}})
	}
}
